import { apiGet, apiDelete } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';
import Backend from '@/app/Dataman-Backend';

export const staffCommentFilesApi = {
  dealStaffCommentFiles: {
    getList: (params) => apiGet(DEALS_PATHS.dealStaffCommentFiles, { params }),
    remove: (id) => apiDelete(`${DEALS_PATHS.dealStaffCommentFiles}/${id}`),
    download: (id) =>
      Backend.loadBlobData({
        url: `${DEALS_PATHS.dealStaffCommentFiles}/${id}/file`,
        method: 'get',
        responseType: 'blob',
        headers: { accept: 'application/octet-stream' },
      }),
    create: ({ deal, file }) => {
      const formData = new FormData();
      formData.append('deal', deal);
      formData.append('file', file);
      return Backend.post({
        url: DEALS_PATHS.dealStaffCommentFiles,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        data: formData,
      });
    },
  },
};
